<div class="centered-loading-spinner" [ngClass]="{'show--spinner': show.loadingSpinner}">
  <dot-loader class="position--fixed" [visibility]="show.loadingSpinner" [description]="loading.campaign || activeCampaign ? 'Laddar kampanj' : null"></dot-loader>
</div>

@if (show.campaign) { 
  <div class="padding--1x padding-top--3x animate" [ngClass]="{'dimmed--loading': show.loadingSpinner}">
    <div class="flex__container--vertical align-items--end campaign-labels">
      <campaign-status-label class="campaign-label" [campaignStatus]="activeCampaign?.status" [needsAttention]="needsAttention"></campaign-status-label>
    </div>
    <div class="flex__container--vertical align-items--end" >
      @if (adminOrPlanner()) {
        <special-campaign-label class="campaign-label"  [campaign]="activeCampaign"></special-campaign-label>
      }
    </div>
    <div class="margin-top--1x">
      <date-span [start]="campaignPeriod.start" [end]="campaignPeriod.end"></date-span>
    </div>
    <div class="margin-top--3x">
      <customer-agency-row [data]="activeCampaign"></customer-agency-row>
      <h3 class="margin-top--none margin-bottom--none word-break--word text--dark-red">{{activeCampaign?.name}}</h3>
    </div>
    @if (!editOngoingCampaign) {
      <div class="margin-top--3x">
        <manage-campaign-buttons
          [campaign]="activeCampaign"
          [campaignStartsToday]="campaignStartsToday"
        ></manage-campaign-buttons>
      </div>
    }
    @if (!editOngoingCampaign && show.button.showStats || show.button.collapse) {
      <div class="margin-top--2x">
          <text-button
          icon=""
          [disabled]="disable.button.showStats"
          (click)="onClickStats()"
        >
          Visa statistik
        </text-button>
        @if (show.button.collapse) {
        <text-button
          icon="TV4_008_fram"
          [disabled]="disable.button.collapse"
          (click)="onClickCollapse()"
        >
          Fäll tillbaka
        </text-button>
        }
      </div>
    }
    <div class="box-container">
      <div class="margin-top--3x">

        <table class="table no-border campaign-summary-table">
          <tbody>
            <tr>
              <td>Total budget</td>
              <td>{{campaignSummary?.totalBudget | wooNullIfZero | currency: 'SEK' | dashAsDefault}}</td>
            </tr>
            @if (show.element.campaignSummaryOrderValue) {
              <tr>
                <td>{{show.element.campaignSummaryNewOrderValue ? 'Initialt ordervärde' : 'Ordervärde'}}</td>
                <td>{{campaignSummary?.orderValue | currency: 'SEK' | dashAsDefault}}</td>
              </tr>
            }
            @if (show.element.campaignSummaryNewOrderValue) {
              <tr>
                <td>Nytt ordervärde</td>
                <td>{{campaignSummary?.newOrderValue | currency: 'SEK' | dashAsDefault}}</td>
              </tr>
            }
            <tr>
              <td>Referensnummer</td>
              <td>{{campaignSummary?.referenceNumber | dashAsDefault}}</td>
            </tr>
            @if (adminOrPlanner()) {
              <tr>
                <td>Internt Id</td>
                <td>{{activeCampaign?.tv4_id | dashAsDefault}}</td>
              </tr>
            }
            <tr>
              <td>Er referens</td>
              <td>{{campaignSummary?.clientInvoiceReference | dashAsDefault}}</td>
            </tr>
            @if (show.element.campaignSummaryOrderRef) {
              <tr>
                <td>Orderreferens</td>
                <td>{{campaignSummary?.orderRef | dashAsDefault}}</td>
              </tr>
            }
            <tr>
              <td>{{campaignSummary?.useUpdatedDate ? 'Senast uppdaterad' : 'Skapades'}}</td>
              <td>{{campaignSummary?.useUpdatedDate ? campaignSummary?.updatedDate : campaignSummary?.createdDate | dashAsDefault}}</td>
            </tr>
            @if (campaignSummary?.bookedDate) {
              <tr>
                <td>Bokad</td>
                <td>{{campaignSummary?.bookedDate | dashAsDefault}}</td>
              </tr>
            }
            @if (campaignSummary?.bookedBy) { 
              <tr>
                <td>Bokad av</td>
                <td>{{campaignSummary?.bookedBy | dashAsDefault}}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    @if (show.element.statusComments) {
      <div class="margin-top--3x margin-bottom--1x">
        @for (statusComment of statusComments; track $index) {
          <heading-with-line [text]="statusComment.title | wooTitleCase"></heading-with-line>
          <div class="display--block campaign-comment-text-box padding-left-right--1x">
            <h4 class="text--medium">{{statusComment?.text | dashAsDefault}}</h4>
          </div>
        }
      </div>
    }
    @if (show.element.viewCurrencyBlock) {
      <div class="margin-top--3x">
      <view-currency-block
        [campaign]="activeCampaign"
        ></view-currency-block>
      </div>
    }
    <div class="margin-top--4x">
      @for (data of targetingBoxData; track $index) {
        @if (editOngoingCampaign || !canEditTargetings) {
          <targeting-box
            class="display--block margin-top--2x"
            [targeting]="data.targeting"
            [metaData]="data.metaData"
            [part]="data.part"
          ></targeting-box>
        } @else {
          <targeting-box
            class="display--block margin-top--2x"
            [targeting]="data.targeting"
            [metaData]="data.metaData"
            [part]="data.part"
            (onEditTargeting)="editTargeting(data.targeting.id)"
            (onEditCreatives)="editCreatives(data.targeting.id)"
          ></targeting-box>
        }
      }
    </div>
    @if (show.button.download) {
      <div class="margin-top--4x">
        <text-button
          icon="download"
          [disabled]="disable.button.download"
          (click)="onClickDownload()"
        >
          Ladda ner bokningsbekräftelse (PDF)
        </text-button>
      </div>
    }
    @if (show.element.campaignSummaryId) {
      <table class="table no-border campaign-summary-table margin-top--1x margin-bottom--none">
        <tbody>
          <tr>
            <td>Kampanj-ID</td>
            <td class="word--break">{{activeCampaign?.id | dashAsDefault}}</td>
          </tr>
        </tbody>
      </table>
    }
  </div>
}
